//  Componente di visualizzazione messaggio in seguito a iscrizione o disiscrizione
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl, } from 'react-intl';

import queryString from 'query-string';

import htmlParserTransform from '../../helpers/htmlParserTransform';

import BodyStyle from '../common/BodyStyle';
import Redirect from '../common/Redirect';
import NewsletterList from '../common/newsletter/NewsletterList';
import Notification from '../common/notification/Notification';
import LegacyTheme from '../common/personalization/LegacyTheme';
import Personalization from '../common/personalization/Personalization';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

import MsgAPI from '../../api/msg/MsgAPI';
import PublicCustomAPI from '../../api/publiccustom/PublicCustomAPI';

import MapperService from '../../services/MapperService';

import deepGetSet from '../../api/deepGetSet';
import FrontendException from '../../models/FrontendException';

import withResizeObserver from '../../hoc/withResizeObserver';
class SubscriptionMsg extends React.Component {
  constructor() {
    super();
    //
    this.mounted = false;
    this.notificationRef = React.createRef();
    //
    this.actionSettings = {};
    this.textSettings = {};
    //
    this.msgSettings = {
      Content: '',
      RedirectURL: ''
    };
    this.listGUID = '';
    this.clientIP = '';
    this.newsletters = [];
    this.showNewsletterList = false;
    this.emailForPreview = 'test@test.com';
    this.styles = ['default', 'blue', 'dark', 'gray', 'green'];
    this.customClass = ''; //  Default
    this.flowConfig = {
      UseCustomMsgs: false,
      CustomMsgs: {},
      UseCustomPages: false,
      CustomPages: {}
    };
    //
    this.state = {
      loading: false,
      showMainContent: false
    };
  }

  componentDidMount() {
    this.mounted = true;

    if (!this.isUserParamsValid()) {
      //  do not use setState directly in componentDidMount
      this.handleError("Load.Msg.ErrorUserParams");
    } else {
      //
      const params = this.props.match.params;

      const actionCode = this.getActionCode(params.idMsg);
      const qsValues = queryString.parse(this.props.location.search);
      //
      Promise.all([
        this.getPublicCustomAction(params.idList, actionCode),
        this.getPublicCustomText(params.idList, actionCode),
        this.getPublicCustomSettings(params.idList),
        this.getListGUID(params.idList),
        this.getClientIP(),
        this.getNewsletterList(params.idList),
        this.getCustomFlowConfig(qsValues.cfc)
      ]).then(() => {
        if (this.flowConfig.UseCustomMsgs) {
          this.msgSettings.Content = this.flowConfig.CustomMsgs[actionCode];
        } else if (deepGetSet(this.textSettings, 'Text')) {
          this.msgSettings.Content = this.textSettings.Text;
        } else {
          const msgLabel = MapperService.getPostEventDefaultMessage(actionCode);

          this.msgSettings.Content = this.props.intl.formatMessage({
            id: msgLabel,
            defaultMessage: msgLabel
          });
        }
        //
        if (this.flowConfig.UseCustomPages) {
          const { IdLandingPage, CustomUrl } = this.flowConfig.CustomPages[actionCode];

          this.actionSettings.IdLandingPage = IdLandingPage;
          this.actionSettings.CustomUrl = CustomUrl;
        }

        //
        if (this.isTrue(params.preview)) {
          this.msgSettings.RedirectURL = '';
          //
          this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, {
            email: this.emailForPreview,
            IPaddress: this.clientIP
          }, false);
        } else {
          if (this.actionSettings.IdLandingPage) {
            this.msgSettings.RedirectURL = '/frontend/LandingPage.aspx?idList=' +
              encodeURIComponent(params.idList) + '&idLP=' + encodeURIComponent(this.actionSettings.IdLandingPage) +
              '&guid=' + encodeURIComponent(this.listGUID);
            this.msgSettings.Content = undefined;
          } else if (this.actionSettings.CustomUrl) {
            this.msgSettings.RedirectURL = this.actionSettings.CustomUrl;
            //
            this.msgSettings.RedirectURL = this.replacePlaceholders(this.msgSettings.RedirectURL, {
              email: qsValues.email,
              IPaddress: this.clientIP
            }, true);
            this.msgSettings.Content = undefined;
          } else {
            this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, {
              email: qsValues.email,
              IPaddress: this.clientIP
            }, false);
          }
        }
        //
        if (this.mounted) {
          this.setState({
            showMainContent: true
          });
        }
      }).catch((error) => {
        this.handleError(error, "default", true);
      })
        .finally(this.stopLoader);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isTrue(paramValue) {
    return ((paramValue == "true") || (paramValue == "1") || (paramValue == "on"));
  }

  isString(param) {
    return (typeof param === "string") || (param instanceof String);
  }

  /**
   * Verifica parametri idList, idMsg, email
   * se vuoti/nulli ritorna false
   */
  isUserParamsValid() {
    const params = this.props.match.params;
    //
    return Boolean(params.idList && params.idMsg);
  }

  handleError = (error, source = "default", fatal = false) => {
    console.error('### error', error);
    let errorLabel = "Load.Common.Error";
    if (error instanceof FrontendException) {
      errorLabel = error.label;
    } else if (this.isString(error)) {
      errorLabel = error;
    }
    //
    this.notificationRef.current.addError(this.props.intl.formatMessage({ id: errorLabel, defaultMessage: errorLabel }), source, false, !fatal);
  }

  getPublicCustomAction(idList, actionCode) {
    return PublicCustomAPI.getAction(idList, actionCode).then((actionSettings) => {
      this.actionSettings = actionSettings;
    });
  }

  getPublicCustomText(idList, actionCode) {
    return PublicCustomAPI.getText(idList, actionCode).then((textSettings) => {
      this.textSettings = textSettings;
    });
  }

  getPublicCustomSettings(idList) {
    return PublicCustomAPI.getSettings(idList).then((listSettings) => {
      this.showNewsletterList = listSettings.ShowPublicEmailMessagesSubscription;
    });
  }

  getListGUID(idList) {
    return PublicCustomAPI.getListGUID(idList).then((listGUID) => {
      this.listGUID = listGUID;
    });
  }

  getClientIP() {
    return PublicCustomAPI.getClientIP().then((clientIP) => {
      this.clientIP = clientIP;
    });
  }

  getCustomFlowConfig(idCustomFlowConfig) {
    return idCustomFlowConfig
      ? PublicCustomAPI.getCustomFlowConfig(idCustomFlowConfig).then(({
        UseCustomMsgs,
        CustomMsgs,
        UseCustomPages,
        CustomPages
      }) => {
        this.flowConfig = {
          UseCustomMsgs,
          CustomMsgs: CustomMsgs.reduce((acc, { Code, Text }) => ({
            ...acc,
            [Code]: Text
          }), {}),
          UseCustomPages,
          CustomPages: CustomPages.reduce((acc, { Code, IdLandingPage, CustomUrl }) => ({
            ...acc,
            [Code]: { IdLandingPage, CustomUrl }
          }), {})

        };
      })
      : Promise.resolve(true)
      ;
  }

  replacePlaceholders(content, map, uriEncode) {
    Object.keys(map).forEach((key) => {
      if (uriEncode) {
        content = content.replaceAll('[' + key + ']', encodeURIComponent(map[key]));
      } else {
        content = content.replaceAll('[' + key + ']', map[key]);
      }
    });
    return content;
  }

  getNewsletterList(idList) {
    return MsgAPI.getNewsletterList(idList).then((newsletters) => {
      this.newsletters = newsletters.MessagesItems;
    });
  }

  getActionCode(idMsg) {
    let result = "";
    switch (parseInt(idMsg, 10)) {
      case 4:
      case 1:
        result = "PostSubscription_GenericError";
        break;

      case 2:
        result = "PostSubscription_SubscriptionRequestCompleted";
        break;

      case 3:
      case 6:
        result = "PostSubscription_SubscriptionCompleted";
        break;

      case 5:
      case 40:
        result = "PostSubscription_RecipientAlreadySubscribed";
        break;

      case 12:
        result = "PostSubscription_RecipientInactive";
        break;

      case 20:
        result = "PostSubscription_RecipientDoesNotExist";
        break;

      case 30:
        result = "PostSubscription_UnableToSendSubscriptionConfirmationRequestMessage";
        break;
    }
    return result;
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    if (this.styles.indexOf(this.props.match.params.style) != -1) {
      this.customClass = this.props.match.params.style;
    }
    const applyCustomCSS = (this.props.match.params.style == 'custom');
    //
    return (
      <div>
        <BodyStyle customClass={this.customClass} />
        {this.customClass &&
          <LegacyTheme style={this.customClass} mode="subscription" />
        }
        <Notification ref={this.notificationRef} />
        {this.state.loading && <LoadingSpinner />}

        {this.state.showMainContent &&
          <React.Fragment>
            {this.msgSettings.RedirectURL &&
              <Redirect to={this.msgSettings.RedirectURL} />
            }

            {this.msgSettings.Content &&
              <div className="frontend-wrapper">
                <Personalization idList={this.props.match.params.idList} showLogo applyCustomCSS={applyCustomCSS} />

                <div className="frontend-box frontend-row">
                  <div className="frontend-row frontend-text-casistica">{parse(this.msgSettings.Content, { replace: htmlParserTransform })}</div>
                </div>

                {this.newsletters.length > 0 && this.showNewsletterList && !this.msgSettings.RedirectURL &&
                  <div className="box-latest-newsletter frontend-row">
                    <h4 className="frontend-title-paragraph frontend-row-x-sm"><FormattedMessage id="Load.Msg.LatestPublishedNewsletters" defaultMessage="Load.Msg.LatestPublishedNewsletters" /></h4>
                    <NewsletterList list={this.newsletters} />
                  </div>
                }
              </div>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

SubscriptionMsg.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      preview: PropTypes.string.isRequired,
      idList: PropTypes.string.isRequired,
      idMsg: PropTypes.string.isRequired,
      email: PropTypes.string,
      style: PropTypes.string
    })
  }),
  location: PropTypes.object,

};

export default withResizeObserver(injectIntl(SubscriptionMsg), 'SubscriptionMsg');